// import { someCookiesAllowed, allowSomeCookies } from './cookies';

const initModules = function initModules()
{
  initShowLayerContent();
  initShowMoreBtn();
  initDefaultBoxToggle();
  initToggleBreadcrumb();
}

function initToggleBreadcrumb()
{
  if (document.getElementById("toggle-breadcrumb")) {
    document.getElementById("toggle-breadcrumb").addEventListener("click", function(event) {
      document.getElementById("breadcrumb").classList.toggle("active");
    });
  }
}



function initShowLayerContent()
{
  $(".toggle-layer").click(function(event){
    const layerId = "#"+ $(this).attr("data-rel");
    const height = $(layerId).innerHeight();

    // $("#footer").toggle();

    $(layerId).toggleClass("active");
    if ($(layerId).hasClass("active")) {
      $('html, body').animate( {
          scrollTop: $(layerId).offset().top-100
        }, 500);

      $(".limitHeight").css({height: height-100}).addClass("layered");
    } else {
      $(".limitHeight").css({height: "auto"}).removeClass("layered");
    }

    return false;
  });
}

// General show more button content module
function initShowMoreBtn()
{
  $(".show-more-btn").click(function(){
    $(this).parents(".js_show-more").toggleClass("show-more");

    $('html, body').animate( {
        scrollTop: $(this).parents(".js_show-more").offset().top-100
      }, 500);

    return false;
  });
}


function initDefaultBoxToggle()
{
  $(".default-box--toggle .default-btn").click(function(){
    let image_src = $(this).attr("data-image");
    $(this).parents(".default-box--toggle").css("background-image", "url("+image_src+")");
  });

  $(".fc-item__inner.toggle-text .default-btn").click(function(){
    $(this).parents(".fc-item__inner").toggleClass("toggled");
  });
}


export { initModules };